import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { MessageService } from 'src/app/core/services/message.service';

@Component({
    selector: 'app-picking-product',
    templateUrl: './picking-product.component.html',
    styleUrls: ['./picking-product.component.scss']
})
export class PickingProductComponent implements OnInit {

    options = {
        columnTitles: ['Id', 'Bulto' , 'Rack'],
        columnReferences: ['id', 'bult', 'rack'],
        actionButtons: { edit: true, delete: true }
    };

    form: FormGroup;
    submitted: boolean;

    dataSource = new BehaviorSubject([]);

    data: any[] = [];
    captured: any[] = [];

    os: string;
    bult: string;
    total = 0;

    constructor(private messageService: MessageService, private formBuilder: FormBuilder) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            os: ['', Validators.required]
        });
    }

    get controls() { return this.form.controls; }

    onLoadBults(): void {
        if (!this.os) {
            return;
        }

        this.clean();

        if (this.os === 'OPS358562') {
            this.loadData();
            this.total = this.data.length;
        } else if (this.os === 'OPS358563') {
            this.messageService.warning('Validación de negocio', 'El Picking ya se encuentra cerrado');
        } else {
            this.messageService.error('Error', 'El OS buscado no existe');
        }
    }

    onEnterBult() {
        if (!this.bult) {
            return;
        }

        const bult = this.data.find(x => x.bult === this.bult);
        if (bult) {
            this.captured.push(bult);
            const index = this.data.indexOf(bult);
            if (index !== -1) {
                this.data.splice(index, 1);
            }
            this.dataSource.next(this.data);
        } else {
            const captured = this.captured.find(x => x.bult === this.bult);
            if (captured) {
                this.messageService.warning('Validación de negocio', 'El bulto ya ha sido capturado');
            } else {
                this.messageService.error('Error', 'El número de bulto no corresponde al conjunto de bultos de la orden de salida');
            }
        }

        this.bult = '';
    }

    onPicking(): void {
        this.submitted = true;
        this.controls.os.markAsTouched();

        if (this.total !== this.captured.length) {
            this.messageService.error('Error', 'Hay bultos pendientes de capturar');
        } else if (!this.form.invalid) {
            this.messageService.success('Éxito', 'Picking exitoso');
            this.cleanAll();
        }
    }

    private clean() {
        this.captured = [];
        this.data = [];
        this.dataSource.next(this.data);
    }

    private cleanAll() {
        this.clean();
        this.total = 0;
        this.os = '';
        this.controls.os.clearValidators();
        this.form.reset({});
    }

    private loadData(): void {
        this.data = [
            { id: 1, bult: '000200OPS22454', rack: 'Rack A2' },
            { id: 2, bult: '000200OPS22455', rack: 'Rack A2' },
            { id: 3, bult: '000200OPS22456', rack: 'Rack A2' },
            { id: 4, bult: '000200OPS22457', rack: 'Rack A3' }
        ];
        this.dataSource.next(this.data);
    }
}
